import { MakeApiCall } from "../../../../apis";

export async function fetchAvailablePlans(token) {
  const res = await MakeApiCall(
    "admin/billing/coupons/available-plans",
    "get",
    null,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to load available plans");
  }
  return res?.data?.plans || [];
}

export async function fetchCoupons({ page = 1, perPage = 20 } = {}, token) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });
  const res = await MakeApiCall(
    `admin/billing/coupons?${params.toString()}`,
    "get",
    null,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to load coupons");
  }
  return {
    coupons: res?.data?.coupons || [],
    pagination: res?.data?.pagination || {
      total: 0,
      page: 1,
      per_page: perPage,
      pages: 1,
    },
  };
}

export async function fetchCoupon(couponId, token) {
  const res = await MakeApiCall(
    `admin/billing/coupons/${couponId}`,
    "get",
    null,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to load coupon");
  }
  return res?.data || null;
}

export async function fetchCouponUsageStats(couponId, token) {
  const res = await MakeApiCall(
    `admin/billing/coupons/${couponId}/usage-stats`,
    "get",
    null,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to load usage statistics");
  }
  return res?.data || null;
}

export async function createCoupon(payload, token) {
  const res = await MakeApiCall(
    "admin/billing/coupons",
    "post",
    payload,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to create coupon");
  }
  return res;
}

export async function updateCoupon(couponId, payload, token) {
  const res = await MakeApiCall(
    `admin/billing/coupons/${couponId}`,
    "put",
    payload,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to update coupon");
  }
  return res;
}

export async function deleteCoupon(couponId, token) {
  const res = await MakeApiCall(
    `admin/billing/coupons/${couponId}`,
    "delete",
    null,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to delete coupon");
  }
  return res;
}
